/**
 * By default, $.getScript() sets the cache setting to false.
 * This function is for fetching a cached script:
 */
const getCachedScript = function(url, options)  {
	// Allow user to set any option except for dataType, cache, and url
	options = $.extend( options || {}, {
		dataType: "script",
		cache: true,
		url: url
	});

	// Use $.ajax() since it is more flexible than $.getScript
	// Return the jqXHR object so we can chain callbacks
	return $.ajax( options );
};

export default getCachedScript;